  
<div class="div-color">
    <div class=" d-flex justify-content-center align-items-center " style="font-size: 30pt; text-align: center; color: green;">
        <i class="fa fa-check-circle fa-3x"></i>           
    </div>
    <p style="text-align: center;font-size: 30pt;  color: green;">{{"Payment Completed Successfully" }}</p>
</div>